import z from 'zod';

// Private firms (docs/private-firms.md): Super Admins see a private firm's client data only while
// the firm has given Lexo an active support access grant. Every access under a grant is recorded

/** How long a grant lasts. The firm's admin picks one when giving Lexo access */
export const SUPPORT_ACCESS_DURATION_HOURS = [1, 24, 168] as const;
export type SupportAccessDurationHours = (typeof SUPPORT_ACCESS_DURATION_HOURS)[number];

export const ALL_AUDIT_EVENT_ACTIONS = [
    /** A Super Admin reached the firm's client data through a grant (once per request) */
    'grant.access',
    'grant.created',
    'grant.revoked',
    'firm.private_enabled',
    'firm.private_disabled',
    /** A Super Admin corrected the billed price of a private firm's transaction */
    'billing.price_changed',
] as const;
export type AuditEventAction = (typeof ALL_AUDIT_EVENT_ACTIONS)[number];

export interface SupportAccessGrant {
    supportAccessGrantId: string;
    lawFirmId: number;
    grantedBy: number;
    grantedByName: string | null;
    startsAt: string;
    expiresAt: string;
    revokedAt: string | null;
    revokedBy: number | null;
    reason: string | null;
}

export interface SupportAccessStatus {
    isPrivate: boolean;
    activeGrant: SupportAccessGrant | null;
    /** The firm's most recent grants, newest first, including the active one */
    recentGrants: SupportAccessGrant[];
}

export interface AuditEvent {
    auditEventId: string;
    occurredAt: string;
    lawFirmId: number | null;
    actorUserId: number | null;
    actorEmail: string | null;
    action: AuditEventAction;
    resourceType: string | null;
    resourceId: string | null;
    supportAccessGrantId: string | null;
    requestMethod: string | null;
    requestPath: string | null;
}

export interface AuditEventListResponse {
    auditEvents: AuditEvent[];
    total: number;
}

export const CreateSupportAccessGrantSchema = z.object({
    durationHours: z.literal(SUPPORT_ACCESS_DURATION_HOURS),
    reason: z.string().trim().max(500).optional(),
});
export type CreateSupportAccessGrant = z.infer<typeof CreateSupportAccessGrantSchema>;

export const UpdateLawFirmPrivacySchema = z.object({
    isPrivate: z.boolean(),
});
